document.addEventListener('click', function(e) {
  const btn = e.target.closest('.quick-buy-btn');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(item => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
      detail: { product: item }
    }));
    btn.disabled = false;
  })
  .catch(() => { btn.disabled = false; });
});
